export default "__VITE_ASSET__kMD62lB0__"